import React from 'react';
import { Link } from 'react-router-dom';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg'
import { Row, Image, Button } from 'react-bootstrap';

import pushAnalytics from '../../../../analytics/pushAnalytics';
import pushLinkAnalytics from '../../../../analytics/pushLinkAnalytics';

import AppVars from '../../../../AppVars';
const appVars = AppVars.getInstance();

const COMPONENT_TREE = [
    { component_name: 'UserExists', component_version: '1.0.0' }
];

class UserExistsView extends React.Component {
    render() {
        return (
            <div>
                <div className="justify-content-center line-box">
                    <div role="banner">
                        <Row className="">
                            <Link to={appVars.getAppHomeURL(this.props.style)}><Image className="corner-logo absolute" alt="Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></Link>
                        </Row>
                    </div>
                    <div role="main">
                        <Row className="justify-content-center location">
                            <div>Registration</div>
                        </Row>
                        <Row className="title__TO left">Sign In</Row>
                        <Row className="justify-content-center text__TO">
                            <b>{this.props.email}</b> is already registered for Toyota Owners, My Lexus or Toyota App. Use the same credentials to sign in to Toyota.
                        </Row>
                        <Row className="justify-content-center text__TO">
                            Do you need help with your account? <br className="mobile-br" /> <Link style={{ "marginTop": "0px" }} className="create-account" href={appVars.getSupportURL(this.props.style)} onClick={() => pushLinkAnalytics({ ctaText: 'Contact Us', href: appVars.getSupportURL(this.props.style), tree: COMPONENT_TREE })}>Contact Us</Link>
                        </Row>
                        <div style={{ 'height': '39px' }}>
                        </div>
                        <div style={{ 'display': 'grid', 'grid-template-rows': '58px', 'grid-template-columns': '90px auto', 'margin': 'auto' }}>
                            <Link to="/" onClick={() => pushAnalytics('aa-action', { button_action: 'goToSignIn', ctaText: 'Sign In', initiator: 'user' }, COMPONENT_TREE)}><Button style={{ 'margin': 'auto' }} data-testid="SignInButton" bsPrefix="button__TO" type="button" >Sign In</Button></Link>
                            <Link className="button-left create-account" to={appVars.getResendActivationEmailURL(this.props.style)} onClick={() => pushLinkAnalytics({ ctaText: 'Resend Activation Link', href: appVars.getResendActivationEmailURL(this.props.style), tree: COMPONENT_TREE })}>Resend Activation Link</Link>
                        </div>
                        <div>
                            <div style={{ 'height': '5px' }}>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UserExistsView;